import React from "react";
import PropTypes from "prop-types";
import {css} from "@emotion/react";
import {breakpoints} from "~styles/global";
import Image from "~components/Image";
// import * as Flickity from 'react-flickity-component'
// import "~styles/flickity.css";
import {Larr, Rarr} from "../Svg";
import {useState, useEffect} from "react";
import useEmblaCarousel from "embla-carousel-react";
import ClickVideo from "./ClickVideo";

const ImageSliderEmbla = ({className, slides, slideToShow, onSlide, height}) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const {mobile} = breakpoints;

  const arrowCss = `
      transform: scale(1);
      transition: transform 0.3s;
      &:hover{
        transform: scale(1.15);
      }
    `;

  const [emblaRef, emblaApi] = useEmblaCarousel();

  useEffect(() => {
    const handleScroll = (e) => setCurrentSlide(e.selectedScrollSnap());
    emblaApi?.on("select", handleScroll);

    return () => emblaApi?.off("select", handleScroll);
  }, [emblaApi]);

  return (
    <div
      className={className}
      css={css`
        position: relative;
      `}
    >
      <div
        css={css`
          margin-bottom: 34px;
          display: flex;
          justify-content: flex-start;
          ${mobile} {
            margin-bottom: 30px;
          }
        `}
      >
        {slides?.map((image, index) => (
          <button
            onClick={() => emblaApi?.scrollTo(index)}
            key={image?.image?.key}
            className={`h6`}
            css={css`
              margin-right: 29px;
              position: relative;
              &:after {
                content: "";
                height: 1px;
                background-color: var(--black);
                opacity: ${index === currentSlide ? `1` : `0`};
                transition: 0.3s opacity;
                position: absolute;
                bottom: -1px;
                left: 0;
                right: 0;
                width: 80%;
                margin: 0 auto;
              }
              ${mobile} {
                margin-right: 24px;
              }
            `}
          >
            {index < 9 ? 0 : null}
            {index + 1}
          </button>
        ))}
      </div>
      <div
        className="embla"
        ref={emblaRef}
        css={css`
          /* height: 100%; */
          margin-bottom: 0px;
        `}
      >
        <div
          className="embla__container"
          css={css`
            height: 100%;
          `}
        >
          {slides?.map((slide, index) => (
            <div
              className="embla__slide"
              css={css`
                margin-right: 20px;
                display: block;
                /* top: 50%; */
                /* transform: translateY(-50%); */
                width: 100%;
                position: relative;
                aspect-ratio: 1.5;
                /* border: 1px solid red; */
                /* padding-bottom: 66.7%; */
                ${mobile} {
                  padding-bottom: 0;
                  width: ${`calc(${slide?.image?.asset?.metadata.dimensions.aspectRatio} * ${height})`};
                  height: ${height};
                  max-width: 100%;
                }
              `}
            >
              {/* {console.log({slide})} */}
              {slide?._type === "productVideo" ? (
                <ClickVideo src={slide?.video?.asset?.url} autoplay={index === 0} />
              ) : (
                <Image
                  asset={slide?.image?.asset}
                  key={slide?.image?.key}
                  css={css`
                    width: 100%;
                    height: 100%;
                    .gatsby-image-wrapper {
                      height: 100%;
                      img {
                        object-fit: contain !important;
                      }
                    }
                  `}
                  //   css={css`
                  //     position: absolute;
                  //     top: 0;
                  //     left: 0;
                  //     bottom: 0;
                  //     right: 0;
                  //     display: grid;
                  //     .gatsby-image-wrapper {
                  //       max-height: 100%;
                  //       img {
                  //         object-fit: contain !important;
                  //       }
                  //     }
                  //     ${mobile}{
                  //     position: relative;
                  //     height: 100%;
                  //     .gatsby-image-wrapper {
                  //       img {
                  //         object-fit: cover !important;
                  //       }
                  //     }
                  //     }
                  // `}
                />
              )}
            </div>
          ))}
        </div>
      </div>
      <div
        css={css`
          display: none;
          ${mobile} {
            display: block;
          }
        `}
      >
        <div
          css={css`
            display: grid;
            transition: min-height 0.3s;
          `}
        >
          {slides?.map((image, index) => (
            <h6
              key={image?.key}
              className={`h6`}
              css={css`
                opacity: ${index === currentSlide ? `1` : `0`};
                transition:
                  opacity 0.3s,
                  min-height 0.3s,
                  margin-top 0.3s;
                transition-delay: 0s, ${index === currentSlide ? `0s` : `0.3s`},
                  ${index === currentSlide ? `0s` : `0.3s`};
                grid-column: 1/2;
                grid-row: 1;
                pointer-events: ${index === currentSlide ? `all` : `none`};
                min-height: ${index === currentSlide && image.imageCaption ? "30px" : "0px"};
                margin-top: ${index === currentSlide && image.imageCaption ? "15px" : "0px"};
              `}
            >
              {image.imageCaption}
            </h6>
          ))}
        </div>
      </div>
      <div
        css={css`
          padding-top: 24px;
          display: grid;
          grid-template-columns: 1fr max-content;
          ${mobile} {
            display: flex;
            justify-content: flex-start;
          }
        `}
      >
        <div
          css={css`
            display: flex;
          `}
        >
          <button
            onClick={() => emblaApi?.scrollPrev()}
            className="h6"
            css={css`
              margin-right: 20px;
              ${mobile} {
                padding: 4px;
              }
            `}
          >
            <Larr
              css={css`
                height: 16px;
                width: 16px;
                ${arrowCss}
                ${mobile} {
                  height: 11px;
                  width: 11px;
                  &:hover {
                    transform: none;
                  }
                }
              `}
            />
          </button>
          <div
            css={css`
              position: relative;
              width: 100%;
              height: 100%;
              display: flex;
              align-items: center;
              ${mobile} {
                display: none;
              }
            `}
          >
            {slides?.map((image, index) => (
              <h6
                key={image?.key}
                className={`h6`}
                css={css`
                  opacity: ${index === currentSlide ? `1` : `0`};
                  transition: 0.3s opacity;
                  position: absolute;
                  left: 0;
                  right: 0;
                `}
              >
                {image.imageCaption}
              </h6>
            ))}
          </div>
        </div>
        <button
          onClick={() => emblaApi?.scrollNext()}
          className="h6"
          css={css`
            ${mobile} {
              padding: 4px;
            }
          `}
        >
          <Rarr
            css={css`
              height: 16px;
              width: 16px;
              ${arrowCss}
              ${mobile} {
                height: 11px;
                width: 11px;
                &:hover {
                  transform: none;
                }
              }
            `}
          />
        </button>
      </div>
    </div>
  );
};

ImageSliderEmbla.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      image: PropTypes.object,
    }),
  ),
  slideToShow: PropTypes.number,
  onSlide: PropTypes.func,
  height: PropTypes.string,
};

// ImageSlider.defaultProps = {
//   // onSlide: n => console.log(n),
// }

export default ImageSliderEmbla;
